import * as React from "react";
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from "@mui/material";

interface LanguageToggleProps {
    /** The auth page sits it on a coloured header; a dialog needs its own ink. */
    color?: string;
}

const LanguageToggle: React.FC<LanguageToggleProps> = ({ color = "white" }) => {
    const { t, i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLang = i18n.language === 'he' ? 'en' : 'he';
        const direction = newLang === 'he' ? 'rtl' : 'ltr';
        i18n.changeLanguage(newLang);
        // עדכון כיוון הטקסט בהתאם לשפה הנוכחית
        document.body.dir = direction;
        document.documentElement.style.setProperty('--dir', direction);
    };

    return (
        <Tooltip title={t('changeLanguage')}>
            <IconButton className="toggle-language-button" onClick={toggleLanguage} size="small" sx={{ color, width: 42, height: 42, p: 2, fontWeight: 700 }}>
                {i18n.language === 'he' ? 'EN' : 'עב'}
            </IconButton>
        </Tooltip>
    );
};

export default LanguageToggle;